import React from 'react'
import { useParams } from 'react-router-dom'
import DetailWrapper from '../../sharedcomponents/4layouts/DetailWrapper'
import useDetailEditMode from '../../sharedcomponents/4layouts/useDetailEditMode'
import LeftCard from '../../sharedcomponents/5templates/detailCards/leftCard'
import ListBucketCard from '../../sharedcomponents/5templates/detailCards/listBucketCard'
import useGroup from './useGroup'
const GroupDetail = ({ createMode }) => {
  const { groupId, type } = useParams()

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode)
  const {
    typeIdToDisplayName,
    useGetOneGroupQuery,
    fetchAuxiliaryRecords,
    bulkUpdateGroupsCallBack,
    upsertGroupCallback,
    groupTypes,
    finalAuxiliaryRecords,
    makeInMemoryGroupRecord,
    removeGroup,
    suspendGroup
  } = useGroup()
  const {
    data: { data: rawGroupRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneGroupQuery(
    {
      include: ['counts'],
      id: groupId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  )
  const primaryGroupRecord = createMode
    ? makeInMemoryGroupRecord(type)
    : JSON.parse(JSON.stringify(rawGroupRecord))
  primaryGroupRecord.refetch = refetch

  const groupMustHaveAtLeastOneOwner = bagOfValues => {
    const errors = {}
    console.log('EXTRA', bagOfValues)

    if (!bagOfValues?.owner_ids?.length) {
      errors.owner_ids = 'At least one owner is required'
    }

    return errors
  }

  return (
    <DetailWrapper
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryGroupRecord}
      isLoading={!createMode && (isLoading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertGroupCallback}
      bulkUpdateCallBack={bulkUpdateGroupsCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
      extraValidation={groupMustHaveAtLeastOneOwner}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        return (
          <>
            <div
              style={{
                float: 'left',
                width: '32.5%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
              }}
            >
              <LeftCard
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeGroup)}
                activationChangeCallback={activationChangeCallback(suspendGroup)}
                listOfTypes={groupTypes}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
                shortFormat={false}
              />
            </div>
            <div
              style={{
                float: 'left',
                width: '32.5%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
              }}
            >
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
            <div
              style={{
                float: 'right',
                width: '32.5%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
              }}
            >
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.tercero}
              />
            </div>
          </>
        )
      }}
    </DetailWrapper>
  )
}
export default React.memo(GroupDetail)
